import React from 'react';
import * as cn from 'classnames';
import PropTypes from 'prop-types';
// import Button from './Button';

const Form = ({
  id,
  className,
  render,
  onSubmit,
  parent,
  parentClassName,
  ...props
}) => {
  const renderForm = () => (
    <form
      {...props}
      className={cn({ [`form-${id}`]: !!id, [className]: !!className })}
      onSubmit={onSubmit}
    >
      {render() || props.children}
      {/* {!!onSubmit && <Button {...onSubmit} type='submit' />} */}
    </form>
  );

  return (
    <>
      {parent ? (
        <div className={parentClassName}>{renderForm()}</div>
      ) : (
        renderForm()
      )}
    </>
  );
};

Form.defaultProps = {
  id: '',
  className: '',
  parentClassName: '',
  // action: 'javascript:void(0)',
  render: () => {},
  onSubmit: () => {},
  // onSubmit: false,
  parent: false,
};

Form.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  parentClassName: PropTypes.string,
  action: PropTypes.string,
  // method: PropTypes.string.isRequired,
  render: PropTypes.func,
  // onSubmit: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  onSubmit: PropTypes.func,
  parent: PropTypes.bool,
};

export default React.memo(Form);
